import {
  BadgeKind,
  BadgeList as BadgeListBase,
  BadgesContainer,
} from '@aboutyou/ui-components';
import React from 'react';

export const BadgeList: React.FC<{
  bottomSpace?: boolean;
  bottomStartExtraSpace?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClickBadge?: VoidFunction;
  increaseRightSideBorderRadius?: boolean;
  badgesList: BadgeKind[];
}> = ({
  bottomSpace = false,
  bottomStartExtraSpace,
  className,
  style,
  onClickBadge,
  increaseRightSideBorderRadius,
  badgesList,
}) => {
  const badgesListProps = {
    entries: badgesList,
    disableRoundedCorners: true,
    onClick: onClickBadge,
    increaseRightSideBorderRadius,
  };

  return (
    <BadgesContainer
      data-testid="BadgesContainer"
      badgesPosition="bottom-start"
      bottomSpace={bottomSpace}
      bottomStartExtraSpace={bottomStartExtraSpace}
      className={className}
      style={style}
    >
      <BadgeListBase {...badgesListProps} />
    </BadgesContainer>
  );
};
